<template>
    <div class="private-instance-list init">
        <div class="cps-page-top">
            <div class="jc-page-header">
                <el-page-header :title="$t('privateNetInstance.cps')" />
                <div class="jc-box-action">
                    <a v-bind:href="Config.CPS_HELP_URL" target="_blank">
                        {{ $t('privateNetInstance.helpDoc') }}
                    </a>
                </div>
            </div>
            <div class="jc-page-content">
                <div class="jc-container-table">
                    <div class="jc-container-table-actionBar flex-display">
                        <el-form class="jc-table-actionBar-item" :inline="true">
                            <el-form-item>
                                <el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="iconRefreshList">
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-radio-group v-model="region" @change="regionChange">
                                    <el-radio-button v-for="(area, index) in regions" :key="index" :label="area.region">
                                        {{ area.regionName }}
                                    </el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="jumpToCreate">
                                    {{ $t('privateNetInstance.create') }}
                                </el-button>
                            </el-form-item>
                        </el-form>
                        <div class="search-input-list">
                            <jcb-combined-search ref='combinedSearch' :filterGroup="filterGroup" :defaultKey="defaultKey"
                                :tags="tags" :matchKeyFunction="matchKeyFunction"
                                :noMatchedSearchKeyTip="$t('list.keySearch')"
                                :matchSearchKeyIntroduction="$t('list.keySearchTip')" @search="handleSearch" />
                            <el-form :inline="true">
                                <!--tag-->
                                <el-form-item>
                                    <jcb-tag-filter :service-code="ServiceCodeConstant.CPS"
                                        :selected-tag-keys="initSelectedTagKeys"
                                        :filter-node-method="handleFilterNodeMethod"
                                        :visible.sync="batchEditTagDialogVisible" :region-id="region"
                                        @checkedTags="filterWithCheckedTags">
                                    </jcb-tag-filter>
                                </el-form-item>
                                <!--自定义设置-->
                                <el-form-item>
                                    <el-button class="jc-button-icon operate-icon" icon="el-icon-setting"
                                        @click="customVisible = true" :title="$t('listPage.text.customList')">
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button class="jc-button-icon operate-icon" icon="jc-icon-download"
                                        @click="showDownload" :title="$t('listPage.text.exportList')">
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div v-if="searchList" class="search-list">
                        <span>{{ this.totalCount === 0 ? $t('list.searchresult1', [totalCount]) : $t('list.searchresult2',
                            [totalCount]) }}</span>
                        <el-button type="text" @click="backTolist()">{{ $t('list.backTolist') }}
                        </el-button>
                    </div>
                    <el-table ref="multipleTable" :data="realTableData" style="width: 100%" @filter-change="filterChange"
                        @selection-change="handleSelectionChange" class="jc-table-header-cell jc-list-table"
                        :empty-text="$t('speechCraft.listEmptyText')" v-loading="loading">
                        <!-- 多选框-->
                        <el-table-column type="selection" width="50" v-if="customInfo !== null">
                        </el-table-column>
                        <!--ID/实例名称-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.name')" key="id"
                            v-if="customInfo !== null && customInfo['id'].selected" width="270">
                            <template slot-scope="scope">
                                <div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()">
                                    <el-tooltip placement="top" :content="scope.row.instanceId">
                                        <div class="left">
                                            <p>{{ scope.row.instanceId }}</p>
                                        </div>
                                    </el-tooltip>
                                    <div class="right" v-show="copyHover">
                                        <copy-value :copyVal="`${scope.row.instanceId}`"></copy-value>
                                    </div>
                                </div>
                                <div>
                                    <el-tooltip placement="top" :content="scope.row.name">
                                        <a href="javascript:void(0)"
                                            @click="jumpToInstanceDetail(scope.row.instanceId, scope.row.region, scope.row.az, scope.row.sn)"
                                            class="instance-id">
                                            {{ scope.row.name }}
                                        </a>
                                    </el-tooltip>
                                    <el-tooltip placement="top"></el-tooltip>
                                </div>
                                <!--操作系统图片-->
                                <div>
                                    <el-tooltip class="item" effect="dark" :content="scope.row.osName" placement="top">
                                        <span :class="[scope.row.osType, 'os-icon']"></span>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                        <!--性能监控-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.monitor')"
                            v-if="customInfo !== null && customInfo['monitor'].selected">
                            <template slot-scope="scope">
                                <performance-monitor-icon :data="scope.row" @click.native="jumpToInstanceDetail(
                                    scope.row.instanceId,
                                    scope.row.region,
                                    scope.row.az,
                                    scope.row.sn,
                                    'performanceMonitor',
                                    scope.row.imageType
                                )" />
                            </template>
                        </el-table-column>
                        <!--可用区-->
                        <el-table-column :filter-multiple="true" column-key="az" prop="az" min-width="85"
                            :filters="filters.azs" :filter-method="filterAz"
                            :label="$t('privateNetInstance.listTitle.region')" key="az"
                            v-if="customInfo !== null && customInfo['az'].selected">
                            <template slot-scope="scope">
                                {{ transformAz(scope.row.az) }}
                            </template>
                        </el-table-column>
                        <!--IP地址-->
                        <el-table-column key="ip" min-width="165" v-if="customInfo !== null && customInfo['ip'].selected">
                            <template slot="header" slot-scope="scope">
                                <el-tooltip :content="$t('listPage.text.targetIpAddressTip')" placement="top-start">
                                    <p class="ipAddressTip">{{ $t('listPage.tableLabel.targetIpAddress') }}<a><i
                                                class="jc-icon-question"></i></a></p>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <div>
                                    <div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()"
                                        v-if="scope.row.publicIp">
                                        <el-tooltip placement="top"
                                            :content="scope.row.publicIp + $t('privateNetInstance.public')">
                                            <div class="left">
                                                <p class="instance-ip">{{ scope.row.publicIp +
                                                    $t('privateNetInstance.public') }}
                                                </p>
                                            </div>
                                        </el-tooltip>
                                        <div class="right" v-show="copyHover">
                                            <copy-value :copyVal="`${scope.row.publicIp}`"></copy-value>
                                        </div>
                                    </div>
                                    <p v-else>{{ '--' + $t('privateNetInstance.public') }}</p>
                                </div>
                                <div>
                                    <div class="inline-ip" @mouseover="ipHover()" @mouseout="ipDisplayNone()"
                                        v-if="scope.row.privateIp">
                                        <el-tooltip placement="top"
                                            :content="scope.row.privateIp + $t('privateNetInstance.private')">
                                            <div class="left">
                                                <p class="instance-ip">{{ scope.row.privateIp +
                                                    $t('privateNetInstance.private') }}
                                                </p>
                                            </div>
                                        </el-tooltip>
                                        <div class="right" v-show="copyHover">
                                            <copy-value :copyVal="`${scope.row.privateIp}`"></copy-value>
                                        </div>
                                    </div>
                                    <p v-else>{{ '--' + $t('privateNetInstance.private') }}</p>
                                </div>
                                <div>
                                    <div class="inline-ip" v-if="scope.row.ipv6Address">
                                        <el-tooltip placement="top"
                                            :content="scope.row.ipv6Address + $t('privateNetInstance.ipv6Address')">
                                            <div class="left">
                                                <p class="instance-ip">{{ scope.row.ipv6Address +
                                                    $t('privateNetInstance.ipv6Address') }}
                                                </p>
                                            </div>
                                        </el-tooltip>
                                    </div>
                                    <p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <!--私有网络/子网-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.privateAndSub')" key="ratio"
                            min-width="110" v-if="customInfo !== null && customInfo['ratio'].selected">
                            <template slot-scope="scope">
                                <el-tooltip :content="scope.row.vpcName" placement="top">
                                    <p class="instance-id">
                                        <a href="javascript:void(0)"
                                            @click="jumpToVpcDetail(scope.row.vpcId, scope.row.region)">
                                            {{ scope.row.vpcName }}
                                        </a>
                                    </p>
                                </el-tooltip>
                                <el-tooltip :content="scope.row.subnetName" placement="top">
                                    <p class="instance-id">
                                        <a href="javascript:void(0)"
                                            @click="jumpToSubnet(scope.row.subnetId, scope.row.region)">
                                            {{ scope.row.subnetName }}
                                        </a>
                                    </p>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!--网络类型-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.netType')" key="networkType"
                            min-width="80" v-if="customInfo !== null && customInfo['networkType'].selected">
                            <template slot-scope="scope">
                                <span>
                                    {{ transformNetWorkType(scope.row.networkType) }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--状态-->
                        <el-table-column :filter-multiple="true" column-key="status" :filters="filters.status"
                            :filter-method="filterStatus" :label="$t('privateNetInstance.listTitle.status')" key="status"
                            prop="status" v-if="customInfo !== null && customInfo['status'].selected" min-width="100">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.status === 'error'"
                                    :content="$t('privateNetInstance.clickCommit')" placement="top">
                                    <span @click="createErrorOrder" :class="['my-error-status', 'jc-status-danger']"
                                        v-if="scope.row.status === 'error'">
                                        {{ transFormStatusName(scope.row.status) }}
                                    </span>
                                </el-tooltip>
                                <span v-else :class="getClassByStatue(scope.row.status)">
                                    <span class="icon-status icon-stopped icon-run"
                                        v-if="scope.row.status !== 'running' && scope.row.status !== 'stopped'">
                                    </span>
                                    {{ transFormStatusName(scope.row.status) }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--规格类型-->
                        <el-table-column :filter-multiple="true" column-key="deviceType" :filters="filters.deviceTypes"
                            :filter-method="filterDeviceType" prop="deviceType"
                            :label="$t('privateNetInstance.listTitle.spc')" key="specifications"
                            v-if="customInfo !== null && customInfo['specifications'].selected" min-width="105">
                            <template slot-scope="scope">
                                <el-tooltip class="item" :content="scope.row.cpsConfiguration.deviceType.name"
                                    effect="dark">
                                    <span class="english-wrap">{{ scope.row.cpsConfiguration.deviceType.name }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <!--配置-->
                        <el-table-column key="config" v-if="customInfo !== null && customInfo['config'].selected"
                            min-width="130">
                            <template slot="header" slot-scope="scope">
                                <el-tooltip :content="$t('listPage.text.configTip')" placement="top-start">
                                    <p class="ipAddressTip">{{ $t('privateNetInstance.listTitle.config') }}<a><i
                                                class="jc-icon-question"></i></a></p>
                                </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                                <p>{{ scope.row.cpsConfiguration.cpu }}</p>
                                <p>{{ scope.row.cpsConfiguration.mem }}</p>
                                <p v-if="scope.row.cpsConfiguration.bw">{{ scope.row.cpsConfiguration.bw }}</p>
                                <p v-else>--</p>
                            </template>
                        </el-table-column>
                        <!--标签-->
                        <el-table-column :label="$t('listPage.text.tags')" key="tag"
                            v-if="customInfo !== null && customInfo['tags'].selected" min-width="70"
                            class-name="p-line-break">
                            <template slot-scope="scope">
                                <p>{{ scope.row.tagPairs | maybeEmpty }}</p>
                            </template>
                        </el-table-column>
                        <!--计费信息-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.charge')" key="chargeInfo" min-width="200"
                            v-if="customInfo !== null && customInfo['chargeInfo'].selected">
                            <template slot-scope="scope">
                                <div v-if="scope.row.charge.chargeExpiredTime !== undefined">
                                    <p>
                                        {{ transformCharge(scope.row.charge.chargeMode) }}
                                        <span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" class="expire-warning">
                                            {{ '(' + $t('listPage.text.hasExpired') + ')' }}
                                        </span>
                                    </p>
                                    <p class="list-expire-p">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                    </p>
                                    <p class="expire-warning list-expire-p bill-info-tip"
                                        v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.charge.chargeRetireTime">
                                        {{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
                                    </p>
                                    <p class="expire-warning list-expire-p bill-info-tip"
                                        v-if="getCheckExpireInfo(scope.row) === 'will-expire'">
                                        {{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
                                    </p>
                                    <p v-if="getCheckExpireInfo(scope.row) === 'available'"
                                        class="list-expire-p bill-info-tip">
                                        {{ scope.row.charge.chargeExpiredTime + ' ' + $t('listPage.text.expired') }}
                                    </p>
                                </div>
                                <div v-else-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
                                    <p>
                                        {{ transformCharge(scope.row.charge.chargeMode) }}
                                        <span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
                                            class="expire-warning expire-warning">
                                            {{ '(' + $t('privateNetInstance.arrear') + ')' }}
                                        </span>
                                    </p>
                                    <p class="list-expire-p bill-info-tip"
                                        v-if="scope.row.charge.chargeStatus === 'normal'">
                                        {{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetInstance.create') }}
                                    </p>
                                    <p class="list-expire-p expire-warning"
                                        v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.charge.chargeRetireTime">
                                        {{ scope.row.charge.chargeRetireTime + ' ' + $t('listPage.text.freed') }}
                                    </p>
                                </div>
                                <div v-else>
                                    <span>--</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!--操作-->
                        <el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation"
                            v-if="customInfo !== null && customInfo['operation'].selected">
                            <template slot-scope="scope">
                                <operate-unit
                                    v-if="['stopped', 'stopping', 'error', 'reinstalling'].includes(scope.row.status)"
                                    :operateName="$t('privateNetInstance.open')" :disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
                                        || operateMap[statusListMap[scope.row.status]].indexOf('start') > -1
                                        || !scope.row.charge.chargeStatus" @handleClick="clickOperateOpen"
                                    :instanceInfo="scope.row"
                                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo') : OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip') : $t('privateNetInstance.operations.onlyShutDown')">
                                </operate-unit>
                                <operate-unit v-else :operateName="$t('privateNetInstance.shutdown')" :disabled="OverdueConstantArray.includes(scope.row.charge.chargeStatus)
                                    || operateMap[statusListMap[scope.row.status]].indexOf('turnOff') > -1
                                    || !scope.row.charge.chargeStatus" @handleClick="clickOperateShutdown"
                                    :instanceInfo="scope.row"
                                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo') : OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip') : $t('privateNetInstance.operations.onlyRunning')">
                                </operate-unit>
                                <operate-unit :operateName="$t('privateNetInstance.restart')" :disabled="operateMap[statusListMap[scope.row.status]].indexOf('restart') > -1
                                    || OverdueConstantArray.includes(scope.row.charge.chargeStatus)
                                    || !scope.row.charge.chargeStatus" @handleClick="clickOperateRestart"
                                    :instanceInfo="scope.row"
                                    :operateTip="!scope.row.charge.chargeStatus ? $t('eip.help.noChargeInfo') : OverdueConstantArray.includes(scope.row.charge.chargeStatus) ? $t('privateNetInstance.operations.overdueTip') : $t('privateNetInstance.operations.onlyRunning')">
                                </operate-unit>
                                <p>
                                    <drop-down-operation :showType="'span'" :buttonTitle="$t('privateNetInstance.more')"
                                        :operations="scope.row.operations" :rowInfo="scope.row"
                                        @clickSelectItem="clickOperate">
                                    </drop-down-operation>
                                </p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <open :visible.sync="openInstance" :name="instanceInfo.name" :instanceId="instanceInfo.instanceId"
                    :region="this.region" @refresh="operateRefresh">
                </open>
                <close :visible.sync="closeInstance" :name="instanceInfo.name" :region="this.region"
                    :instanceId="instanceInfo.instanceId" @refresh="operateRefresh">
                </close>
                <restart :visible.sync="restartInstanceVisible" :name="instanceInfo.name" :region="this.region"
                    :instanceId="instanceInfo.instanceId" @refresh="operateRefresh">
                </restart>
                <repassword :visible.sync="repasswordInstance"></repassword>
                <!--重装系统第一次弹框-->
                <reinstall :visible.sync="reInstall" :rowInfo="rowInfo" v-if="reInstall">
                </reinstall>
                <re-network :visible.sync="reNetwork" :rowInfo="rowInfo" :azs="azs" :region="this.region" v-if="reNetwork"
                    @refresh="operateRefresh">
                </re-network>
                <bind-eip v-if="bindShow" :visible.sync="bindShow" :region="rowInfo.region" :instanceId="rowInfo.instanceId"
                    :instanceName="rowInfo.name" :rowInfo="rowInfo" @refresh="operateRefresh">
                </bind-eip>
                <un-bind-eip :visible.sync="unBindShow" :elasticIpId="rowInfo.elasticIpId" :publicIp="rowInfo.publicIp"
                    :region="rowInfo.region" :instanceId="rowInfo.instanceId" @refresh="operateRefresh">
                </un-bind-eip>
                <have-sos :visible.sync="sosShow" :rowInfo="rowInfo" @refresh="operateRefresh">
                </have-sos>
                <fix-sos :visible.sync="fixSOSShow" :rowInfo="rowInfo" @refresh="operateRefresh">
                </fix-sos>
                <reset-sos :visible.sync="resetSOSShow" :rowInfo="rowInfo" @refresh="operateRefresh">
                </reset-sos>
                <custom v-if="customVisible" :visible.sync="customVisible" :optionArr="optionArr" :type="type">
                </custom>
            </div>
        </div>
        <div v-if="listTotal > 0" class="cps-page-footer block jc-container-table-actionBar">
            <div class="fl mt10">
                <el-checkbox @change="handleCheckAllChange" v-model="hasCheckAll" class="mr20"></el-checkbox>
                <el-tooltip placement="top" :disabled="isAllowBatchClose">
                    <div slot="content">{{ multipleSelection.length ? $t('retailInstance.tooltip.turnOff') :
                        $t('retailInstance.tooltip.chooseTips') }}</div>
                    <span>
                        <el-button type="primary" class="w70" :disabled="!isAllowBatchClose" @click="showBatchCloseDialog">
                            {{ $t('privateNetInstance.shutdown') }}
                        </el-button>
                    </span>
                </el-tooltip>
                <el-tooltip placement="top" :disabled="isAllowBatchOpen">
                    <div slot="content">{{ multipleSelection.length ? $t('retailInstance.tooltip.turnOn') :
                        $t('retailInstance.tooltip.chooseTips') }}</div>
                    <span>
                        <el-button type="primary" class="w70" :disabled="!isAllowBatchOpen" @click="showBatchOpenDialog">
                            {{ $t('privateNetInstance.open') }}
                        </el-button>
                    </span>
                </el-tooltip>
                <drop-down-operation class="batch-operation-button" :showType="'button'"
                    :buttonTitle="$t('privateNetInstance.more')" :operations="batchOperations"
                    @clickSelectItem="clickBatchOperate">
                </drop-down-operation>
            </div>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="listTotal">
            </el-pagination>
        </div>
        <reset-password :dialogVisible.sync="resetPasswordDialogVisible" :detail-data="rowInfo"
            @refreshData="iconRefreshList">
        </reset-password>
        <!--操作保护-->
        <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="actionType" @success="onSuccess"
            @error="onError">
        </jcb-opt-protect>
        <!--编辑标签-->
        <jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPS"
            :region-id="rowInfo.region !== undefined ? rowInfo.region : ''"
            :resource-ids="rowInfo.instanceId !== undefined ? [rowInfo.instanceId] : []"
            @complete="refreshWithLoading(null, true)">
        </jcb-tag-edit>
        <!--删除实例-->
        <delete-instance :visible.sync="deleteVisible" @refresh="operateRefresh" :rowInfo="rowInfo" :pageSource="'list'">
        </delete-instance>
        <!-- 下载 -->
        <download-selection :visible.sync="downloadVisible" :currentPage="currentPage" :pageSize="pageSize"
            :filterParams="filterParams" :searchParams="params" :networkType="networkType"
            :multipleSelection="multipleSelection" :region="region" @refresh="operateRefresh">
        </download-selection>
        <!--批量关机-->
        <batch-close :visible.sync="batchCloseVisible" @refresh="batchOperateRefresh" :multipleSelection="multipleSelection"
            :showDifferent="showDifferent" :region="region">
        </batch-close>
        <!-- 批量开机 -->
        <batch-open :visible.sync="batchOpenVisible" @refresh="batchOperateRefresh" :multipleSelection="multipleSelection"
            :showDifferent="showDifferent" :region="region">
        </batch-open>
        <!-- 批量重启 -->
        <batch-restart :visible.sync="batchRestartVisible" @refresh="batchOperateRefresh"
            :multipleSelection="multipleSelection" :showDifferent="showDifferent" :region="region">
        </batch-restart>
        <!--批量编辑标签-->
        <jcb-tag-edit :visible.sync="batchEditTagDialogVisible" :service-code="ServiceCodeConstant.CPS" :region-id="region"
            :resource-ids="multipleSelectionId" @complete="batchOperateRefresh">
        </jcb-tag-edit>
        <!-- 批量重置密码 -->
        <batch-repassword :visible.sync="batchRepasswordVisible" @refresh="batchOperateRefresh"
            :multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
        </batch-repassword>
        <!-- 批量编辑实例名称 -->
        <batch-rename :visible.sync="batchRenameVisible" @refresh="batchOperateRefresh"
            :multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
        </batch-rename>
        <!-- 批量删除 -->
        <batch-delete :visible.sync="batchDeleteVisible" @refresh="batchOperateRefresh"
            :multipleSelection="multipleSelection" :showDifferent="showDifferent1" :region="region">
        </batch-delete>
        <!--开通ipv6-->
        <ipv6-privateNetInstance :visible.sync="ipv6PrivateNetInstanceShow"
            :region="rowInfo.region !== undefined ? rowInfo.region : ''" :currentRow="rowInfo" @refresh="refreshList({})">
        </ipv6-privateNetInstance>
        <!--添加别名ip范围弹框-->
        <add-alias-ip-range-dialog :dialog-visible.sync="addIpAliasRangeDialogVisible" :detail-data="rowInfo"
            @refreshDetailData="refreshList({})">
        </add-alias-ip-range-dialog>
        <!--开启实例删除操作保护-->
        <enable-deletion-protection :visible.sync="enableDeletionProtectionVisible" :instanceName="rowInfo.name"
            :region="rowInfo.region" :instanceId="rowInfo.instanceId" @refresh="refreshList({})">
        </enable-deletion-protection>
        <!--关闭实例删除操作保护-->
        <disable-deletion-protection :visible.sync="disableDeletionProtectionVisible" :instanceName="rowInfo.name"
            :region="rowInfo.region" :instanceId="rowInfo.instanceId" @refresh="refreshList({})">
        </disable-deletion-protection>
        <!--制作镜像-->
        <make-mirror :visible.sync="makeMirrorVisible" v-if="makeMirrorVisible" @refresh="operateRefresh" :rowInfo="rowInfo"
            :pageSource="'list'">
        </make-mirror>
    </div>
</template>

<script>
import BindEip from '@/components/common/BindEip';
import unBindEip from '@/components/common/UnBindEip';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import operateUnit from '@/components/privateNetInstance/operateUnit/OperateUnit';
import custom from '@/components/common/custom/Custom';
import open from '@/components/privateNetInstance/operates/Open';
import close from '@/components/privateNetInstance/operates/Close';
import restart from '@/components/privateNetInstance/operates/Restart';
import repassword from '@/components/privateNetInstance/operates/Repassword';
import reinstall from '@/components/privateNetInstance/reinstallSystem/reinstallSystemConfirm';
import ReNetwork from '@/components/privateNetInstance/operates/ReNetwork';
import DeleteInstance from '@/components/common/DeleteInstance';
import PerformanceMonitorIcon from '@/components/common/PerformanceMonitorIcon';
import ResetPassword from '@/components/common/resetPassword/ResetPassword';
import operationProtect from '@/mixins/operationProject';
import isDestroyingMixins from '@/mixins/isDestroying';
import BatchClose from '@/components/common/BatchClose';
import BatchOpen from '@/components/common/BatchOpen';
import BatchRestart from '@/components/common/BatchRestart';
import BatchRepassword from '@/components/common/BatchRepassword';
import BatchRename from '@/components/common/BatchRename';
import BatchDelete from '@/components/common/BatchDelete';
import HaveSos from '@/components/common/HaveSos';
import FixSos from '@/components/common/FixSos';
import ResetSos from '@/components/common/ResetSos';
import Ipv6PrivateNetInstance from '@/components/privateNetInstance/ipv6PrivateNetInstance/ipv6PrivateNetInstance';
import AddAliasIpRangeDialog from '@/components/common/addAliasIpRangeDialog/AddAliasIpRangeDialog';
import EnableDeletionProtection from '@/components/common/enableDeletionProtection/EnableDeletionProtection';
import DisableDeletionProtection from '@/components/common/disableDeletionProtection/DisableDeletionProtection';
import DownloadSelection from '@/components/common/retailInstance/DownloadSelection';
import copyValue from '@/components/privateNetwork/CopyValue';
import makeMirror from '@/components/privateNetInstance/makeMirror/Index';
import {
    ServiceCodeConstant,
    OverdueConstantArray,
    ArrearConstantArray,
    ChargeModeConstant
} from "@/common/Constants";
import { deepCopy } from '@/common/tool';
export default {
    name: 'PrivateNetInstanceList',
    mixins: [operationProtect, isDestroyingMixins],
    components: {
        PerformanceMonitorIcon,
        open,
        close,
        BindEip,
        unBindEip,
        dropDownOperation,
        operateUnit,
        custom,
        restart,
        repassword,
        reinstall,
        ReNetwork,
        ResetPassword,
        DeleteInstance,
        Ipv6PrivateNetInstance,
        AddAliasIpRangeDialog,
        BatchClose,
        BatchOpen,
        BatchRestart,
        BatchRepassword,
        BatchRename,
        BatchDelete,
        HaveSos,
        FixSos,
        ResetSos,
        DownloadSelection,
        copyValue,
        EnableDeletionProtection,
        DisableDeletionProtection,
        makeMirror
    },
    data() {
        return {
            timer: null,
            keyKey: 1,
            initSelectedTagKeys: [], // ['121*212', '3232*3231'],
            totalCount: 0, // 列表总数
            loading: false,
            statusMapName: {
                'creating': this.$t('privateNetInstance.statueNames.creating'),
                'starting': this.$t('privateNetInstance.statueNames.starting'),
                'running': this.$t('privateNetInstance.statueNames.running'),
                'stopping': this.$t('privateNetInstance.statueNames.stopping'),
                'stopped': this.$t('privateNetInstance.statueNames.stopped'),
                'restarting': this.$t('privateNetInstance.statueNames.restarting'),
                'error': this.$t('privateNetInstance.statueNames.error'),
                'upgrading': this.$t('privateNetInstance.statueNames.upgrading'),
                'reinstalling': this.$t('privateNetInstance.statueNames.reinstalling'),
                'destroying': this.$t('privateNetInstance.statueNames.destroying'),
                'inconfig': this.$t('privateNetInstance.statueNames.inconfig'),
                'resetting_password': this.$t('listPage.text.resettingPassword'),
                'making': this.$t('privateNetInstance.statueNames.making'),
            },
            azs: [],
            interStatus: ['creating', 'starting', 'stopping', 'restarting', 'upgrading',
                'reinstalling', 'destroying', 'inconfig', 'resetting_password', 'making', 'stopped'], // 增加stopped 状态，防止出现重新系统回到此页面后不轮询列表，操作按钮点击别的就接口报错了
            instanceInfo: {},
            rowInfo: {},
            openInstance: false,
            closeInstance: false,
            restartInstanceVisible: false,
            downloadVisible: false,
            repasswordInstance: false,
            reInstall: false,
            reNetwork: false,
            operateMap: {
                stopped: [
                    'restart'
                ],
                running: [
                    'reinstall',
                    'resetPassword',
                    'reNetwork',
                    'delete'
                ],
                error: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6'
                ],
                creating: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'sos',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6'
                ],
                upgrading: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6'
                ],
                destroying: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'renew',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6'
                ],
                other: [
                    'start',
                    'turnOff',
                    'restart',
                    'resetPassword',
                    'reinstall',
                    'reNetwork',
                    'bandWidth',
                    'editTag',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6',
                    'sos'
                ],
                noOperate: [
                    'starting',
                    'running',
                    'stopping',
                    'stopped',
                    'error',
                    'restarting',
                    'creating',
                    'destroying',
                    'upgrading',
                    'reinstalling',
                    'turnOnDeleteProtect',
                    'turnOffDeleteProtect',
                    'delete',
                    'ipv6'
                ]
            },
            statusListMap: {
                'starting': 'other',
                'running': 'running',
                'stopping': 'other',
                'stopped': 'stopped',
                'error': 'error',
                'restarting': 'other',
                'creating': 'creating',
                'destroying': 'destroying',
                'upgrading': 'upgrading',
                'reinstalling': 'other',
                'noOperate': 'noOperate',
                'other': 'other',
                'inconfig': 'other',
                'resetting_password': 'other',
                'making': 'other'
            },
            operationsRenew: false,
            // 自定义列表弹框显示
            customVisible: false,
            type: 'vpcInstanceList',
            statusMap: {
                // 关机
                'shutdown': 'jc-status-warning',
                // 运行
                'run': 'jc-status-success',
                // 中间态
                'intermediate': ' my-status my-status-middle ',
                // 错误
                'error': 'jc-status-danger',
            },
            placeholderMap: {
                instanceIds: this.$t('privateNetInstance.placeholderId'),
                name: this.$t('privateNetInstance.placeholderName'),
                privateIp: this.$t('list.searchPlaceholder.privateIp')
            },
            unBindShow: false,
            bindShow: false,
            sosShow: false,
            fixSOSShow: false,
            resetSOSShow: false,
            sosTip: '',
            region: '',
            regions: [],
            inputValue: '',
            tableData: [],
            filterGroup:
                [
                    {	//实例名称
                        label: this.$t('privateNetInstance.instanceName'),
                        key: "name",
                        multiValue: false,
                        notice: this.$t('list.fuzzySearchTip')
                    },
                    {	//实例ID
                        label: this.$t('privateNetInstance.instanceID'),
                        key: "instanceId",
                        multiValue: true,
                        notice: this.$t('list.exactSearchTip')
                    },
                    {	//IPv4公网
                        label: this.$t('subnet.text.publicIp'),
                        key: "publicIp",
                        multiValue: true,
                        notice: this.$t('list.exactSearchTip')
                    },
                    {	//IPv4内网
                        label: this.$t('subnet.text.privateIp'),
                        key: "privateIp",
                        matchModes: [{
                            key: "fuzzy",
                            label: this.$t('list.fuzzySearch')
                        }, {
                            key: "exact",
                            label: this.$t('list.exactSearch')
                        }],
                        notice: this.$t('list.IPsearchTip')
                    },
                    { 	//状态
                        label: this.$t('list.status'),
                        key: "status",
                        multiValue: true,
                        selectOptions: [],
                        notice: this.$t('list.mutisearchTip')
                    },
                    { 	//规格类型
                        label: this.$t('list.specifications'),
                        key: "deviceType",
                        multiValue: true,
                        selectOptions: [],
                        notice: this.$t('list.mutisearchTip')
                    },
                ],
            defaultKey: "name",
            tags: [],
            params: {},
            searchList: false,
            copyHover: false,
            searchLists: {
                azs: [],
                interfaceModes: [],
                deviceTypes: [],
                status: []
            },
            filters: {
                azs: [],
                deviceTypes: [],
                status: []
            },
            filterParams: {
                az: '',
                deviceTypeList: '',
                status: ''
            },
            flexPublicNetList: [],
            networkType: 'vpc',
            currentPage: 1,
            pageSizes: [20, 50, 100],
            pageSize: 20,
            optionArr: [
                {
                    // ID/名称
                    label: this.$t('privateNetInstance.listTitle.name'),
                    value: 'id'
                },
                {
                    // 监控
                    label: this.$t('privateNetInstance.listTitle.monitor'),
                    value: 'monitor'
                },
                {
                    // 可用区
                    label: this.$t('privateNetInstance.listTitle.region'),
                    value: 'az'
                },
                {
                    // 主IP地址
                    label: this.$t('listPage.tableLabel.targetIpAddress'),
                    value: 'ip'
                },
                {
                    // 私有网络/子网
                    label: this.$t('privateNetInstance.listTitle.privateAndSub'),
                    value: 'ratio'
                },
                {
                    // 网络类型
                    label: this.$t('privateNetInstance.listTitle.netType'),
                    value: 'networkType'
                },
                {
                    // 状态
                    label: this.$t('privateNetInstance.listTitle.status'),
                    value: 'status'
                },
                {
                    // 规格
                    label: this.$t('privateNetInstance.listTitle.spc'),
                    value: 'specifications'
                },
                {
                    // 配置
                    label: this.$t('privateNetInstance.listTitle.config'),
                    value: 'config'
                },
                {
                    // 标签
                    label: this.$t('listPage.text.tags'),
                    value: 'tags'
                },
                {
                    // 计费信息
                    label: this.$t('privateNetInstance.listTitle.charge'),
                    value: 'chargeInfo'
                },
                {
                    // 操作
                    label: this.$t('privateNetInstance.listTitle.operate'),
                    value: 'operation'
                }
            ],
            statusTimeOut: null,
            resetPasswordDialogVisible: false,
            // 给操作保护用区分物理机类型：basic/vpc
            instanceType: 'vpc',
            // 编辑标签组件是否显示
            editTagDialogVisible: false,
            // 批量编辑标签组件是否显示
            batchEditTagDialogVisible: true,
            // 标签过滤后的资源ID
            filteredResourceIds: [],
            // 删除实例弹框
            deleteVisible: false,
            // 开通ipv6弹框
            ipv6PrivateNetInstanceShow: false,
            // 添加别名IP范围dialog
            addIpAliasRangeDialogVisible: false,
            // 多选框选中的实例
            multipleSelection: [],
            multipleSelectionInstanceInfo: {},
            isAllowBatchClose: false,
            isAllowBatchOpen: false,
            isAllowBatchRestart: false,
            isAllowBatchEditTag: false,
            isAllowBatchRepassword: false,
            isAllowBatchRename: false,
            isAllowBatchDelete: false,
            batchCloseVisible: false,
            batchOpenVisible: false,
            batchRestartVisible: false,
            batchEditTagDialogVisible: false,
            batchRepasswordVisible: false,
            batchRenameVisible: false,
            batchDeleteVisible: false,
            hasCheckAll: false,
            showDifferent: {
                hasCollapse: false,
                ipLabelType: "mainIp",
                hasBandWith: true
            },
            showDifferent1: {
                hasCollapse: true,
                ipLabelType: "mainIp",
                hasBandWith: true
            },
            // 开启实例删除操作保护弹框
            enableDeletionProtectionVisible: false,
            // 关闭实例删除操作保护弹框
            disableDeletionProtectionVisible: false,
            // 制作镜像弹框
            makeMirrorVisible: false

        };
    },
    computed: {
        ServiceCodeConstant: () => ServiceCodeConstant,
        customInfo() {
            return this.$store.state.customInfo[this.type];
        },
        realTableData() {
            if (typeof this.tableData === 'undefined') {
                return [];
            }
            if (this.tableData.length === 0) {
                return [];
            }
            return this.tableData.map((item) => {
                const ipv6Disabled = (item) => {
                    if (item.interfaceMode === 'bond') {
                        return !!item.ipv6Address || (!item.ipv6Address && (!item.subnetIpv6Cidr || !item.vpcIpv6Cidr));
                    } else if (item.interfaceMode === 'dual') {
                        return (!!item.ipv6Address && !!item.extensionIpv6Address) || (!item.ipv6Address && (!item.subnetIpv6Cidr || !item.vpcIpv6Cidr) && !item.extensionIpv6Address && (!item.extensionSubnetIpv6Cidr || !item.extensionVpcIpv6Cidr));
                    }
                }
                // 兼容status人工误修改的情况
                let operate = this.statusListMap[item.status] || 'other';
                const operations = [
                    {
                        operateName: this.$t('privateNetInstance.operations.rePassword'),
                        disabled: this.operateMap[operate].indexOf('resetPassword') !== -1
                            || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                        value: 'rePassword'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.reOperateSystem'),
                        disabled: this.operateMap[operate].indexOf('reinstall') > -1
                            || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyShutDown'),
                        value: 'reInstall'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.ipv6'),
                        disabled: this.operateMap[operate].indexOf('ipv6') > -1 || ipv6Disabled(item) || OverdueConstantArray.includes(item.charge.chargeStatus) || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : (item.ipv6Address && item.extensionIpv6Address) ? this.$t('privateNetInstance.operations.onlyOneIpv6') : '',
                        value: 'ipv6'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.makeMirror'),
                        disabled: item.status !== 'stopped' || OverdueConstantArray.includes(item.charge.chargeStatus) || item.deviceSource !== 'common' || item.customPartition.dataDiskPartitions.some(item => item.point === '/var') || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : item.deviceSource !== 'common' ? this.$t('privateNetInstance.operations.wrongDeviceType') : (item.status !== 'stopped' ? this.$t('privateNetInstance.operations.onlyShutDown') : ''),
                        value: 'makeMirror'
                    },
                    {
                        operateName: this.$t('privateNetInstance.operations.repay'),
                        disabled: this.operateMap[operate].indexOf('renew') > -1
                            || !item.charge.chargeStatus,
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : '',
                        value: 'repay'
                    },
                ];

                // 解绑
                if (item.enableInternet === 'yes') {
                    operations.splice(3, 0, {
                        operateName: this.$t('privateNetInstance.operations.unbind'),
                        disabled: (item.status !== 'running'
                            && item.status !== 'stopped')
                            || typeof item.charge.chargeStatus === 'undefined'
                            || OverdueConstantArray.includes(item.charge.chargeStatus)
                            || this.instanceByConfigOpesDisabled(item),
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyNotError'),
                        value: 'unbind'
                    });
                }
                // 绑定
                operations.splice(3, 0, {
                    operateName: this.$t('privateNetInstance.operations.bind'),
                    disabled: (item.status !== 'running'
                        && item.status !== 'stopped')
                        || typeof item.charge.chargeStatus === 'undefined'
                        || OverdueConstantArray.includes(item.charge.chargeStatus)
                        || this.instanceByConfigOpesDisabled(item),
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.$t('privateNetInstance.operations.onlyNotError'),
                    value: 'bind'
                });
                if (item.imageType === 'Windows') {
                    this.sosTip = this.$t('privateNetInstance.operations.notWindows');
                } else {
                    this.sosTip = ''
                };
                if (item.keypairIdSos !== undefined) {
                    //SOS
                    operations.splice(4, 0, {
                        operateName: this.$t('privateNetInstance.operations.sos'),
                        disabled: typeof item.charge.chargeStatus === 'undefined' || OverdueConstantArray.includes(item.charge.chargeStatus)
                            || item.imageType === 'Windows',
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.sosTip,
                        value: 'sos'
                    });
                    //重置SOS
                    operations.splice(5, 0, {
                        operateName: this.$t('privateNetInstance.operations.resetSOS'),
                        disabled: !item.charge.chargeStatus || OverdueConstantArray.includes(item.charge.chargeStatus)
                            || item.imageType === 'Windows',
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.sosTip,
                        value: 'resetSos'
                    });
                } else {
                    // 修复SOS
                    operations.splice(4, 0, {
                        operateName: this.$t('privateNetInstance.operations.fixSOS'),
                        disabled: !item.charge.chargeStatus || OverdueConstantArray.includes(item.charge.chargeStatus)
                            || item.imageType === 'Windows',
                        tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : OverdueConstantArray.includes(item.charge.chargeStatus) ? this.$t('privateNetInstance.operations.overdueTip') : this.sosTip,
                        value: 'fixSos'
                    });
                };
                // 编辑标签
                operations.push({
                    operateName: this.$t('operations.edit_tag.name'),
                    disabled: this.operateMap[operate].indexOf('editTag') > -1
                        || typeof item.charge.chargeStatus === 'undefined',
                    tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('operations.edit_tag.tip'),
                    value: 'editTag'
                });
                //更换子网网络
                const changeNetworkOperate = {
                    operateName: this.$t('privateNetInstance.operations.reVpcnetWork'),
                    disabled: this.operateMap[operate].indexOf('reNetwork') > -1
                        || typeof item.charge.chargeStatus === 'undefined'
                        || OverdueConstantArray.includes(item.charge.chargeStatus)
                        || item.checkModifyVpc?.ifSlb
                        || item.checkModifyVpc?.ifAliasIp
                        || item.checkModifyVpc?.ifIPv6
                        || item.checkModifyVpc?.ifEip
                        || item.checkModifyVpc?.ifNatRules,
                    tip: '',
                    value: 'reNetwork'
                };
                if (item.checkModifyVpc?.ifAliasIp) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyBindOtherIp');
                }
                if (item.checkModifyVpc?.ifEip) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyBindEip');
                }
                if (item.checkModifyVpc?.ifIPv6) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyHaveIPv6');
                }
                if (item.checkModifyVpc?.ifNatRules) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyHaveNatRules');
                }
                if (item.checkModifyVpc?.ifSlb) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.alreadyAddLb');
                }
                if (item.status !== 'stopped') {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.onlyShutDown');
                }
                if (OverdueConstantArray.includes(item.charge.chargeStatus)) {
                    changeNetworkOperate.tip = this.$t('privateNetInstance.operations.overdueTip');
                }
                if (!item.charge.chargeStatus) {
                    changeNetworkOperate.tip = this.$t('eip.help.noChargeInfo');
                }
                operations.splice(2, 0, changeNetworkOperate);
                // 添加别名IP
                const addIpAliasRangeOperate = {
                    operateName: this.$t('subnet.text.addIpAliasRange'),
                    disabled: (item.status !== 'running' && item.status !== 'stopped')
                        || typeof item.charge.chargeStatus === 'undefined'
                        || OverdueConstantArray.includes(item.charge.chargeStatus)
                        || (item.isCheckAliasIpTotal >= 50 && item.extensionAliasIpTotal >= 50)
                        || this.instanceByConfigOpesDisabled(item),
                    tip: '',
                    value: 'addIpAlias'
                };
                if (item.isCheckAliasIpTotal >= 50 && item.extensionAliasIpTotal >= 50) {
                    addIpAliasRangeOperate.tip = this.$t('subnet.help.only10IpAliasForOneInstance');
                }
                if (item.status !== 'running' && item.status !== 'stopped') {
                    addIpAliasRangeOperate.tip = this.$t('privateNetInstance.operations.onlyNotError');
                }
                if (OverdueConstantArray.includes(item.charge.chargeStatus)) {
                    addIpAliasRangeOperate.tip = this.$t('privateNetInstance.operations.overdueTip');
                }
                if (!item.charge.chargeStatus) {
                    addIpAliasRangeOperate.tip = this.$t('eip.help.noChargeInfo');
                }
                operations.splice(3, 0, addIpAliasRangeOperate);
                // 开启实例删除保护
                if (item.removeProtect === 'no') {
                    const turnOnDeleteProtect = {
                        operateName: this.$t('operations.turnOnDeleteProtect.name'),
                        disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                            || typeof item.charge.chargeStatus === 'undefined'
                            || this.operateMap[operate].indexOf('turnOnDeleteProtect') > -1
                            || this.instanceByConfigOpesDisabled(item),
                        value: 'turnOnDeleteProtect',
                        tip: ''
                    };
                    if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                        turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip');
                    }
                    if (this.instanceByConfigOpesDisabled(item)) {
                        turnOnDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.tip');
                    }
                    if (!item.charge.chargeStatus) {
                        turnOnDeleteProtect.tip = this.$t('eip.help.noChargeInfo');
                    }
                    operations.push(turnOnDeleteProtect);
                }
                if (item.removeProtect === 'yes') {
                    // 关闭实例删除保护
                    const turnOffDeleteProtect = {
                        operateName: this.$t('operations.turnOffDeleteProtect.name'),
                        disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                            || typeof item.charge.chargeStatus === 'undefined'
                            || this.operateMap[operate].indexOf('turnOffDeleteProtect') > -1
                            || this.instanceByConfigOpesDisabled(item),
                        value: 'turnOffDeleteProtect',
                        tip: ''
                    };
                    if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                        turnOffDeleteProtect.tip = this.$t('operations.turnOnDeleteProtect.prepaidTip')
                    }
                    if (this.instanceByConfigOpesDisabled(item)) {
                        turnOffDeleteProtect.tip = this.$t('operations.turnOffDeleteProtect.tip')
                    }
                    if (!item.charge.chargeStatus) {
                        turnOffDeleteProtect.tip = this.$t('eip.help.noChargeInfo');
                    }
                    operations.push(turnOffDeleteProtect);
                }

                // 删除实例特殊处理
                const deleteOperate = {
                    operateName: this.$t('operations.delete.name'),
                    disabled: item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION
                        || typeof item.charge.chargeStatus === 'undefined'
                        || this.operateMap[operate].indexOf('delete') > -1
                        || (item.status === 'stopped' && !!item.ipv6AddressId)
                        || item.removeProtect === 'yes',
                    value: 'delete',
                    tip: ''
                };
                if (item.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION && item.status === 'stopped' && item.ipv6AddressId) {
                    deleteOperate.tip = this.$t('operations.delete.tipWithIPv6')
                }
                if (item.removeProtect === 'yes') {
                    deleteOperate.tip = this.$t('operations.delete.tipWithRemoveProtect');
                }
                if (this.operateMap[operate].indexOf('delete') > -1) {
                    deleteOperate.tip = this.$t('operations.delete.tipWithStatus');
                }
                if (item.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION) {
                    deleteOperate.tip = this.$t('operations.delete.tip');
                }
                if (!item.charge.chargeStatus) {
                    deleteOperate.tip = this.$t('eip.help.noChargeInfo');
                }
                operations.push(deleteOperate);
                item.operations = operations;
                return item;
            });
        },
        /**
         * 返回查询到的列表总数
         * @return {number}
        */
        listTotal() {
            return this.totalCount;
        },
        OverdueConstantArray: () => OverdueConstantArray,
        ArrearConstantArray: () => ArrearConstantArray,
        ChargeModeConstant: () => ChargeModeConstant,
        batchOperations() {
            const operations = [{
                operateName: this.$t('operations.reset_password.name'),
                disabled: !this.isAllowBatchRepassword,
                tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.repassword') : this.$t('retailInstance.tooltip.chooseTips'),
                value: 'repassword'
            }, {
                operateName: this.$t('privateNetInstance.restart'),
                disabled: !this.isAllowBatchRestart,
                tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.restart') : this.$t('retailInstance.tooltip.chooseTips'),
                value: 'restart'
            }, {
                operateName: this.$t('operations.rename.name'),
                disabled: !this.isAllowBatchRename,
                tip: this.multipleSelection.length ? '' : this.$t('retailInstance.tooltip.chooseTips'),
                value: 'rename'
            }, {
                operateName: this.$t('operations.edit_tag.name'),
                disabled: !this.isAllowBatchEditTag,
                tip: this.multipleSelection.length ? this.$t('operations.edit_tag.tip') : this.$t('retailInstance.tooltip.chooseTips'),
                value: 'editTag'
            }, {
                operateName: this.$t('operations.delete.name'),
                disabled: !this.isAllowBatchDelete,
                tip: this.multipleSelection.length ? this.$t('retailInstance.tooltip.delete') : this.$t('retailInstance.tooltip.chooseTips'),
                value: 'delete'
            },]
            return operations
        },
        multipleSelectionId() {
            return this.multipleSelection.map(item => item.instanceId)
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path === '/instance/vpc/create') {
                vm.iconRefreshList();
            }
        });
    },
    created() {
        if (this.$store.state.customInfo[this.type] === null) {
            this.getCustomInfo();
        }
        this.getRegions();

    },
    destroyed() {
        clearTimeout(this.statusTimeOut);
    },
    watch: {
        region(newValue) {
            if (newValue) {
                this.regionChange()
            }
        },
    },
    methods: {
        /**
         * @description 标签展示的过滤方法, 返回 true表示节点可以展示，否则节点被忽略
         */
        handleFilterNodeMethod () {
            // const tag = sessionStorage.getItem('jcb-tag-filter-tagKeys')
            // if (tag) {
            //     this.initSelectedTagKeys = JSON.parse(tag)
            // }
            // const resIds = sessionStorage.getItem('jcb-tag-filter-resourceIds')
            // if (resIds) {
            //     this.filteredResourceIds = JSON.parse(resIds);
            // }
            return true;
        },
        /**
         **@disc: 根据标签对实例进行过滤
         **@author: mengln
        */
        filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
            this.initSelectedTagKeys = tagKeys;
            this.filteredResourceIds = resourceIds;
            // @TODO 暂时保留该逻辑，测试通过后可以删除
            // if (tagKeys.length !== 0) {
            //     this.filteredResourceIds = resourceIds;
            // }
            // this.refreshWithLoading(null, this.filteredResourceIds.length !== 0);
            this.refreshWithLoading(null);
        },
        /**
         * 判断当前时间与到期、释放时间关系
         * @param row
         * @return {string}
        */
        getCheckExpireInfo(row) {
            if (row.charge.chargeExpiredTime !== undefined) {
                const now = Date.now();
                const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
                const DAYS = 1000 * 60 * 60 * 24;
                if (now > expire && row.charge.chargeRetireTime) {
                    return 'will-retire';
                }
                if (expire - now > 7 * DAYS) {
                    return 'available';
                }
                return 'will-expire';
            }
        },
        /*
         根据当前状态（返回字段statue）判断单个操作disabled
        */
        checkOperationDisable(data, status, chargeStatus) {
            let bool = this.operateMap[this.statusListMap[data.status]].indexOf(status) > -1;
            if (chargeStatus) bool = bool || OverdueConstantArray.includes(data.charge.chargeStatus);
            return bool;
        },
        // 切换可用区
        regionChange() {
            // TODO remember to clear search
            this.tags = [],
                this.params = {},
                this.inputValue = '';
            this.pageSize = 20;
            this.currentPage = 1;
            this.hasCheckAll = false;
            this.resetMultipleSelection();
            const params = {
                region: this.region,
                networkType: 'vpc'
            };
            Object.keys(this.filterParams).forEach((filter) => {
                this.filterParams[filter] = '';
            });
            this.refreshList(params);
            this.getFilterLists();
        },
        // 获得可用区
        getRegions() {
            const params = {
                networkType: 'vpc'
            };
            Ajax.get('api/cps/getRegions', params).then((res) => {
                const target = this;
                if (res.data) {
                    res.data.regions.forEach((region, index) => {
                        if (index === 0) {
                            if (target.$route.query && target.$route.query.region) {
                                target.region = target.$route.query.region;
                            } else {
                                target.region = region.region;
                            }
                        }
                        const tempFormat = {};
                        tempFormat.region = region.region;
                        tempFormat.regionName = region.regionName;
                        target.regions.push(tempFormat);
                    });
                }
            })
                .catch()
                .finally(() => {
                    this.loading = false
                });;
        },
        // 查询实例列表
        getInstanceList(params) {
            return Ajax.get('/api/cps/listInstances', params).then((res) => {
                if (res.data) {
                    // 格式化返回的标签键值对
                    for (const item of res.data.instances) {
                        item.tagPairs = '';
                        if (item.tags !== undefined && item.tags.length > 0) {
                            for (const tag of item.tags) {
                                item.tagPairs += `${tag.key}:${tag.value},`;
                            }
                            item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
                        }
                        item.chargeMode = item.charge.chargeMode;
                    }
                    this.tableData = res.data.instances;
                    let multipleSelectionInstanceInfo = deepCopy(this.multipleSelectionInstanceInfo)
                    this.$nextTick(() => {
                        this.tableData.map(item => {
                            let instanceId = item.instanceId;
                            if (multipleSelectionInstanceInfo[instanceId]) {
                                this.$refs.multipleTable.toggleRowSelection(item, true)
                            }
                        })
                    })
                    this.totalCount = res.data.totalCount;
                }
            })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (e) {
                        console.log(e);
                    }
                })
                .finally(() => {
                    this.loading = false
                });
        },
        // 获得过滤
        getFilterLists() {
            const params = {
                region: this.region,
                networkType: 'vpc'
            };
            Ajax.get('/api/filter/listInstances', params).then((res) => {
                if (res.errno === 10000 && res.data) {
                    Object.keys(res.data).forEach((key) => {
                        const filtersArray = [];
                        const filtersObj = res.data[key];
                        Object.keys(filtersObj).forEach((item) => {
                            const temp = {};
                            temp.value = item;
                            temp.text = filtersObj[item];
                            filtersArray.push(temp);
                        });
                        this.filters[key] = filtersArray;
                        var json = JSON.parse(JSON.stringify(filtersArray).replace(/value/g, "key"))
                        this.searchLists[key] = JSON.parse(JSON.stringify(json).replace(/text/g, "label"))
                    });
                    this.filterGroup.forEach((item) => {
                        if (item.key === 'status') {
                            item.selectOptions = this.searchLists.status;
                        }
                        if (item.key === 'deviceType') {
                            item.selectOptions = this.searchLists.deviceTypes;
                        }
                    })
                }
            }).finally(() => {
                this.azs = this.filters.azs;
                this.loading = false;
            });
        },
        filterAz(value, row) {
            if (value) {
                this.searchList = true
            }
            return row.az === value;
        },
        filterStatus(value, row) {
            if (value) {
                this.searchList = true
            }
            return row.status === value;
        },
        filterDeviceType(value, row) {
            if (value) {
                this.searchList = true
            }
            return row.deviceType === value;
        },
        ipHover() {
            this.copyHover = true
        },
        ipDisplayNone() {
            this.copyHover = false
        },
        createErrorOrder() {
            Normal.goWorkPage();
        },
        // 续费
        renew(id) {
            const params = {
                resourceId: id,
                region: this.region,
                serviceCode: ServiceCodeConstant.CPS,
                resourceName: 'a'
            };
            Ajax.get('/api/order/submitRenew', params).then((res) => {
                const tempOrderId = res.data.tmpOrderId;
                window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cps`;
            });
        },
        clickOperate(value, rowInfo) {
            this.rowInfo = rowInfo;
            switch (value) {
                case 'bind':
                    this.bindShow = true;
                    break;
                case 'unbind':
                    this.unBindShow = true;
                    break;
                case 'rePassword':
                    Pop.resetPassword(this, rowInfo);
                    break;
                case 'makeMirror':
                    this.makeMirrorVisible = true;
                    break;
                case 'repay':
                    this.renew(rowInfo.instanceId);
                    break;
                case 'reInstall':
                    this.reInstall = true;
                    break;
                case 'reNetwork':
                    this.reNetwork = true;
                    break;
                case 'editTag':
                    this.editTagDialogVisible = true;
                    break;
                case 'delete':
                    this.deleteVisible = true;
                    break;
                case 'addIpAlias':
                    this.addIpAliasRangeDialogVisible = true;
                    break;
                case 'ipv6':
                    this.ipv6PrivateNetInstanceShow = true;
                    break;
                case 'sos':
                    this.sosShow = true;
                    break;
                case 'fixSos':
                    this.fixSOSShow = true;
                    break;
                case 'resetSos':
                    this.resetSOSShow = true;
                    break;
                case 'turnOnDeleteProtect':
                    this.enableDeletionProtectionVisible = true;
                    break;
                case 'turnOffDeleteProtect':
                    this.disableDeletionProtectionVisible = true;
                default:
                    break;
            }
        },
        // 获取弹性公网列表
        getFlexPublicNetList() {
            const params = {
                region: this.region,
                status: 'disassociate'
            };
            Ajax.get('/api/cps/listElasticIps', params).then((res) => {
                this.flexPublicNetList = res.data.elasticIps;
            }).catch()
                .finally();
        },
        /**
         * @param size
         * 改变当前每页条数时触发
        */
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 切换每页条数时自动返回第一页
            const params = {
                pageSize: size,
            };
            this.refreshWithLoading(params);
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            const params = {
                pageNumber: page
            };
            this.refreshWithLoading(params);
        },
        handleSearch(tags) {
            this.params = {};
            tags.map((item) => {
                if (item.key === "instanceId") {
                    this.params.instanceIds = item.values.toString();
                }
                if (item.key === "name") {
                    this.params.name = item.values.toString();
                }
                if (item.key === "privateIp") {
                    this.params.privateIps = item.values.toString();
                }
                if (item.key === "publicIp") {
                    this.params.publicIps = item.values.toString();
                }
                if (item.key === "status") {
                    this.params.status = item.values.toString();
                }
                if (item.key === "deviceType") {
                    this.params.deviceTypeList = item.values.toString();
                }
            });
            this.searchOfList(this.params);
            if (tags.length !== 0) {
                this.searchList = true;
            } else {
                this.searchList = false;
            }
        },
        matchKeyFunction(keyValue) {
            let instanceIdReg = /^cps-[a-z0-9]/ig
            let ipv4Reg = /^((10|172|192)\.)((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){2}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
            keyValue = keyValue.replace(/，/g, ',').split(',')[0]
            if (instanceIdReg.test(keyValue)) {
                return {
                    key: 'instanceId'
                }
            } else if (ipv4Reg.test(keyValue)) {
                return {
                    key: 'privateIp',
                    matchMode: "fuzzy"
                }
            }
            return false

        },
        // 返回最初列表
        backTolist() {
            this.tags = [];
            this.params = {};
            this.filterParams = {
                az: '',
                deviceTypeList: '',
                status: ''
            };
            this.searchList = false;
            this.pageSize = 20;
            this.currentPage = 1;
            this.hasCheckAll = false;
            this.resetMultipleSelection();
            this.$refs.multipleTable.clearFilter();
            this.refreshList(this.params);
            this.refreshWithLoading(this.params);

        },
        // 刷新列表
        refreshList(params) {
            if (this.isDestroying) {
                return
            }
            const defaultParams = {
                region: this.region,
                networkType: 'vpc',
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            Object.keys(this.filterParams).forEach((key) => {
                if (this.filterParams[key] !== '') {
                    defaultParams[key] = this.filterParams[key];
                }
            });
            const realParams = Object.assign({}, defaultParams, this.params, params);
            const timeoutParams = Object.assign({}, defaultParams, this.params);
            this.getInstanceList(realParams).then(() => {
                const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
                if (refreshTag) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.refreshList(timeoutParams);
                    }, 5000);
                }
            });
        },
        // 临时增加遮罩层
        refreshWithLoading(params, ifFilter = true) {
            if (this.isDestroying) {
                return
            }
            this.loading = true;
            const defaultParams = {
                region: this.region || this.$route.query?.region,
                networkType: 'vpc',
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
            };
            if (ifFilter) {
                // 循环调用时，需要记录tag检索项
                defaultParams.instanceIds = this.filteredResourceIds.join(',');
            }
            Object.keys(this.filterParams).forEach((key) => {
                if (this.filterParams[key] !== '') {
                    defaultParams[key] = this.filterParams[key];
                }
            });
            const realParams = Object.assign({}, defaultParams, params, this.params);
            const timeoutParams = Object.assign({}, defaultParams, this.params);
            this.getInstanceList(realParams).then(() => {
                this.loading = false;
                const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
                if (refreshTag) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.refreshList(timeoutParams);
                    }, 5000);
                }
            }).finally(() => {
                this.loading = false
            })
        },
        searchOfList(params, ifFilter = false) {
            this.loading = true;
            const defaultParams = {
                region: this.region,
                networkType: 'vpc',
                pageNumber: 1,
                pageSize: this.pageSize,
            };
            if (ifFilter) {
                defaultParams.instanceIds = this.filteredResourceIds.join(',');
            }
            Object.keys(this.filterParams).forEach((key) => {
                if (this.filterParams[key] !== '') {
                    defaultParams[key] = this.filterParams[key];
                }
            });
            const realParams = Object.assign({}, defaultParams, params, this.params);
            const timeoutParams = Object.assign({}, defaultParams, this.params);
            this.getInstanceList(realParams).then(() => {
                this.loading = false;
                const refreshTag = this.tableData.some(item => this.interStatus.includes(item.status));
                if (refreshTag) {
                    clearTimeout(this.statusTimeOut);
                    this.statusTimeOut = setTimeout(() => {
                        this.refreshList(timeoutParams);
                    }, 5000);
                }
            }).finally(() => {
                this.loading = false
            })
        },
        iconRefreshList() {
            const params = {};
            this.refreshWithLoading(params, true);
        },
        filterChange(filter) {
            this.currentPage = 1;
            //通过列表项的筛选条件自动获得的搜索框的搜索条件
            var tag = {};
            Object.keys(filter).forEach((key) => {
                if (key === 'az') {
                    this.filterParams.az = filter[key].toString();
                } else if (key === 'status') {
                    this.filterParams.status = filter[key].toString();
                } else if (key === 'deviceType') {
                    this.filterParams.deviceTypeList = filter[key].toString();
                } else if (key === 'interfaceMode') {
                    this.filterParams.interfaceModes = filter[key].toString();
                }
                tag.key = key;
                tag.values = filter[key];
                if (this.tags.length === 0 && tag.values.length) {
                    this.tags.push(tag);
                } else {
                    let isAdd = true;
                    this.tags.forEach((item, index) => {
                        if (item.key === tag.key) {
                            item.values = tag.values;
                            if (tag.values.length === 0) {
                                this.tags.splice(index, 1);
                            }
                            isAdd = false;
                        }
                    })
                    if (isAdd && tag.values.length) {
                        this.tags.push(tag)
                    }
                }
                if (!this.tags.length) {
                    this.searchList = false;
                }
            });
            this.refreshList();
        },
        // 自定义列
        getCustomInfo() {
            const params = {
                pageKey: this.type
            };
            Ajax.get('/api/usercenter/getCustomInfo', params).then((res) => {
                if (res.data.customInfo) {
                    this.$store.commit(
                        'GET_CUSTOMINFO',
                        { value: res.data.customInfo, type: this.type }
                    );
                }
            }).catch(err => {
                console.log(err);
            })
        },
        clickOperateShutdown(operate, instance) {
            if (!operate) {
                this.instanceInfo = instance;
                Pop.vpcInstance_close(this, instance, 'list');
            }
        },
        clickOperateOpen(operate, instance) {
            if (!operate) {
                this.instanceInfo = instance;
                Pop.vpcInstance_open(this, instance, 'list');
            }
        },
        clickOperateRestart(operate, instance) {
            if (!operate) {
                this.instanceInfo = instance;
                Pop.vpcInstace_restart(this, instance, 'list');
            }
        },
        operateRefresh() {
            this.refreshWithLoading({});
        },
        checkExpire(row) {
            if (row.charge.chargeExpiredTime !== undefined) {
                const nowDate = new Date();
                const expireDate = new Date(row.charge.chargeExpiredTime);
                const retireDate = new Date(row.charge.chargeRetireTime);
                const nowTime = nowDate.getTime();
                const expireTime = expireDate.getTime();
                const retireTime = retireDate.getTime();
                if (retireTime - nowTime < 7 * 24 * 3600 * 1000) {
                    return 'will-retire';
                }
                if (expireTime - nowTime < 7 * 24 * 3600 * 1000) {
                    return 'will-expire';
                }
                return 'available';
            }
        },
        transformCharge(payMethod) {
            switch (payMethod) {
                case 'prepaid_by_duration':
                    return this.$t('privateNetInstance.monthAndYear');
                case 'postpaid_by_duration':
                    return this.$t('create.text.byConfigurations');
                default:
                    return '';
            }
        },
        // 按照要求全部返回私有网络
        transformNetWorkType(netType) {
            switch (netType) {
                default:
                    return this.$t('privateNetInstance.privateNet');
            }
        },
        jumpToCreate() {
            this.$router.push({
                path: '/instance/vpc/create',
                query: { region: this.region }
            });
        },
        jumpToSubnet(id, region) {
            this.$router.push({
                path: '/subnet/detail',
                query: {
                    id,
                    region
                }
            });
        },
        jumpToVpcDetail(id, region) {
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    id,
                    region,
                    tabName: 'source'
                }
            });
        },

        jumpToInstanceDetail(id, region, az, sn, tabName = 'sourceInfo', imageType, cpsType = 'cps-vpc') {
            const regionName = this.getRegionName(region);
            this.$router.push({
                path: '/instance/vpc/detail/performance',
                query: {
                    id,
                    region,
                    az,
                    sn,
                    tabName,
                    imageType,
                    cpsType
                }
            });
        },
        transformDeviceType(device) {
            switch (device) {
                case 'storage':
                    return this.$t('privateNetInstance.types.storage');
                case 'gpu':
                    return this.$t('privateNetInstance.types.GPU');
                case 'compute':
                    return this.$t('privateNetInstance.types.compute');
                default:
                    return '';
            }
        },
        transformAz(vaule) {
            let realAz;
            this.azs.forEach((az) => {
                if (az.value === vaule) {
                    realAz = az.text;
                }
            });
            return realAz;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            this.hasCheckAll = val.length === this.tableData.length ? true : false;
            let isAllowBatchClose = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
            this.isAllowBatchClose = isAllowBatchClose;
            let isAllowBatchOpen = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;;
            this.isAllowBatchOpen = isAllowBatchOpen;
            let isAllowBatchRestart = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'running' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;
            this.isAllowBatchRestart = isAllowBatchRestart;
            let isAllowBatchEditTag = this.multipleSelection.length ? this.multipleSelection.every(item => this.operateMap[this.statusListMap[item.status]].indexOf('editTag') < 0 && item.charge.chargeStatus) : false;
            this.isAllowBatchEditTag = isAllowBatchEditTag;
            let isAllowBatchRepassword = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && !OverdueConstantArray.includes(item.charge.chargeStatus)) : false;;
            this.isAllowBatchRepassword = isAllowBatchRepassword;
            let isAllowBatchRename = this.multipleSelection.length ? this.multipleSelection.every(item => item.charge.chargeStatus) : false;
            this.isAllowBatchRename = isAllowBatchRename;
            let isAllowBatchDelete = this.multipleSelection.length ? this.multipleSelection.every(item => item.status === 'stopped' && item.charge.chargeStatus && item.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION) : false;
            this.isAllowBatchDelete = isAllowBatchDelete;
            let multipleSelectionInstanceInfo = {};
            this.multipleSelection.map(item => {
                multipleSelectionInstanceInfo[item.instanceId] = item;
            })
            this.multipleSelectionInstanceInfo = multipleSelectionInstanceInfo;
        },

        resetMultipleSelection() {
            this.multipleSelection = [];
            this.multipleSelectionInstanceInfo = {};
        },

        batchOperateRefresh() {
            this.resetMultipleSelection();
            this.refreshWithLoading({});
        },
        showBatchCloseDialog() {
            this.batchCloseVisible = true;
        },
        showBatchOpenDialog() {
            this.batchOpenVisible = true;
        },
        showDownload() {
            this.downloadVisible = true;
        },
        handleCheckAllChange(event) {
            this.realTableData.map(item => {
                this.$refs.multipleTable.toggleRowSelection(item, event)
            })
        },
        clickBatchOperate(value) {
            switch (value) {
                case 'restart':
                    this.batchRestartVisible = true;
                    break;
                case 'editTag':
                    this.batchEditTagDialogVisible = true;
                    break;
                case 'repassword':
                    this.batchRepasswordVisible = true;
                    break;
                case 'rename':
                    this.batchRenameVisible = true;
                    break;
                case 'delete':
                    this.batchDeleteVisible = true;
                    break;
                default:
                    break;
            }
        },
        getRegionName(region) {
            let regionName = '';
            this.regions.forEach((item) => {
                if (region === item.region) {
                    regionName = item.regionName;
                }
            });
            return regionName;
        },
        getClassByStatue(status) {
            switch (status) {
                case 'running':
                    return ['jc-status-success'];
                case 'error':
                    return ['jc-status-danger'];
                case 'stopped':
                    return ['jc-status-warning'];
                default:
                    return ['my-status', 'my-status-middle'];
            }
        },
        transFormStatusName(status) {
            return this.statusMapName[status];
        },
        /**
            * 当按配置购买的实例处于欠费状态时
            * 除删除操作外，其余操作置灰
            * @param item
            * @return {boolean}
        */
        instanceByConfigOpesDisabled(item) {
            return item.charge.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION
                && OverdueConstantArray.includes(item.charge.chargeStatus);
        },
    },

};
</script>

<style lang="scss">
@import '../../../assets/scss/listComon';
@import '../../../assets/scss/paginationCommon';
@import '../../../assets/scss/sliderCommon';
@import '../../../assets/scss/statusCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/privateNetInstance/list/PrivateNetInstanceList.vue